import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { motion } from "framer-motion";
import { useSite } from "@/context/SiteContext";
import FAQSection from "@/components/FAQSection";

const AboutUs = () => {
  const { config } = useSite();
  const [milestones, setMilestones] = useState([]);
  useEffect(() => {
    api.get("/journey").then((r) => setMilestones(r.data));
  }, []);

  return (
    <div data-testid="about-page">
      <section className="pt-28 md:pt-40 pb-16">
        <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-12">
          <p className="text-xs uppercase tracking-[0.3em] text-ahm-orange font-semibold mb-6">Our story</p>
          <h1 className="font-display text-6xl md:text-8xl lg:text-9xl leading-[0.85] text-ahm-teal text-balance">
            {config.about_intro_title || "A studio born from restlessness."}
          </h1>
          <p className="mt-10 max-w-3xl text-lg md:text-xl text-ahm-teal/85 leading-relaxed">
            {config.about_intro_body}
          </p>
        </div>
      </section>

      {/* Journey */}
      <section className="relative" data-testid="journey-timeline">
        <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="relative">
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-ahm-teal/20" />
            {milestones.map((m, i) => (
              <motion.div
                key={m.id || i}
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] }}
                className={`relative py-16 md:py-24 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 ${i % 2 ? "md:flex-row-reverse" : ""}`}
              >
                <div className={`${i % 2 ? "md:col-start-2" : ""}`}>
                  <div className="flex items-center gap-4 mb-4">
                    <span className="font-mono text-xs uppercase tracking-[0.3em] text-ahm-orange">— {m.year}</span>
                  </div>
                  <h3 className="font-display text-4xl md:text-6xl leading-[0.95] text-ahm-teal text-balance">{m.title}</h3>
                  <p className="mt-6 text-base md:text-lg text-ahm-teal/80 leading-relaxed">{m.body}</p>
                </div>
                <div className={`${i % 2 ? "md:col-start-1 md:row-start-1" : ""}`}>
                  <div className="rounded-2xl overflow-hidden aspect-[4/3] bg-ahm-muted shadow-xl">
                    <img src={m.image} alt={m.title} className="w-full h-full object-cover" />
                  </div>
                </div>
                <div className="hidden md:block absolute left-1/2 top-24 -translate-x-1/2 w-3 h-3 rounded-full bg-ahm-orange ring-4 ring-ahm-cream" />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <FAQSection page="about" />
    </div>
  );
};

export default AboutUs;
